/* eslint-disable consistent-return */
/* eslint-disable default-case */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import ModalSection from '../ModalSection';
import ProductSyncCancelModal from './ProductSyncCancelModal';
import PromptModel from '../../../../models/PromptModel';
import { SIDEBAR_ACTIONS } from '../../../../../constants/actionsConstants';
import RightModalLayout from '../../../../layouts/Modal/RightModalLayout';
import QuillComponent from '../QuillComponent';

const ProductModal = ({ agentId }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('ChatbotIA');

  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isUnsavedChangesModalOpen, setIsUnsavedChangesModalOpen] = useState(false);
  const [prompt, setPrompt] = useState('');
  const [promptId, setPromptId] = useState(null);
  const [originalPrompt, setOriginalPrompt] = useState('');

  useEffect(() => {
    if (agentId) {
      loadData();
    }
  }, [agentId]);

  const hasPromptChanges = () => {
    return prompt !== originalPrompt;
  };

  const toggleProductModal = () => {
    if (hasPromptChanges()) {
      setIsUnsavedChangesModalOpen(true);
      return;
    }
    dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR });
  };

  const loadData = () => {
    if (!agentId) {
      showtoast(t('config.error_loading'));
      setLoading(false);
      return;
    }

    setLoading(true);
    PromptModel.get(agentId, { type: 'product' })
      .then((promptResponse) => {
        const prompts = promptResponse.data || [];
        const productPrompt = prompts.find(p => p.type === 'product');

        if (productPrompt) {
          setPrompt(productPrompt.prompt || '');
          setPromptId(productPrompt.id);
        } else {
          setPrompt('');
          setPromptId(null);
        }
        setOriginalPrompt(productPrompt?.prompt || '');
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        showtoast(err.error || err.message || t('config.error_loading'));
      });
  };

  const onSubmit = () => {
    if (!agentId) {
      showtoast(t('config.error_loading'));
      return;
    }

    setSaving(true);

    const params = {
      prompt: prompt,
      type: 'product'
    };

    const savePromise = promptId
      ? PromptModel.update(agentId, promptId, params)
      : PromptModel.save(agentId, params);

    savePromise
      .then((result) => {
        if (!promptId && result?.id) {
          setPromptId(result.id);
        }
        showtoast(t('config.save_success'));
        setOriginalPrompt(prompt);
        setSaving(false);
        dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR });
      })
      .catch((error) => {
        setSaving(false);
        showtoast(error.message || t('config.save_error'));
      });
  };

  const handleUnsavedChangesConfirm = () => {
    setIsUnsavedChangesModalOpen(false);
    dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR });
  };

  const handleUnsavedChangesDismiss = () => {
    setIsUnsavedChangesModalOpen(false);
  };

  const updateInfo = (value) => {
    setPrompt(value);
  };

  return (
    <div className="tw-wrapper">
      <RightModalLayout
        title={t('config.product_prompt.modal_title')}
        submitAction={onSubmit}
        submitLabel={t('guides.sidebar_create.update')}
        submitDisabled={saving || loading}
        closeAction={toggleProductModal}
      >
        <div className="tw-flex tw-flex-col tw-gap-6">
          <ModalSection
            title={t('config.product_prompt.section_2_title')}
            description={t('config.product_prompt.section_2_description')}
            afterContent={(
              <QuillComponent
                name="prompt"
                value={prompt || ''}
                onChange={updateInfo}
                maxLength={1500}
                overflowHidden={false}
                style={{ height: 'calc(100vh - 400px)' }}
              />
            )}
          />
        </div>

        <ProductSyncCancelModal
          isOpen={isUnsavedChangesModalOpen}
          onClose={handleUnsavedChangesDismiss}
          onConfirm={handleUnsavedChangesConfirm}
          loading={false}
          title={t('config.product_prompt.unsaved_changes_title')}
          description={t('config.product_prompt.unsaved_changes_description')}
          cancelText={t('config.product_prompt.cancel')}
          confirmText={t('config.product_prompt.close_without_saving')}
        />
      </RightModalLayout>
    </div>
  );
};

export default ProductModal;
